import { isNil, lowerCase } from 'lodash'

const itsNotAltered = false

export const isLaboratoryTestPropertyAltered = (propertyInterpretationValue?: string): boolean => {
  if (!propertyInterpretationValue) return itsNotAltered

  const altered = ['high', 'low', 'critical', 'abnormal', 'positive', 'extreme high', 'extreme low']
  return altered.includes(lowerCase(propertyInterpretationValue))
}

interface getQuantitativePropertyReferenceValueProps {
  lowerValue?: number
  upperValue?: number
  label?: string
}

export const getQuantitativePropertyReferenceValue = ({
  lowerValue,
  upperValue,
  label = ''
}: getQuantitativePropertyReferenceValueProps): string => {
  let value = ''

  const thereIsOnlyLowerValue = !isNil(lowerValue) && isNil(upperValue)
  if (thereIsOnlyLowerValue) value = `${label} >= ${String(lowerValue)}`

  const thereIsOnlyUpperValue = isNil(lowerValue) && !isNil(upperValue)
  if (thereIsOnlyUpperValue) value = `${label} <= ${String(upperValue)}`

  const thereAreNoLowerAndUpperValues = isNil(lowerValue) && isNil(upperValue)
  if (thereAreNoLowerAndUpperValues) return ''

  const thereAreBothLowerAndUpperValues = !isNil(lowerValue) && !isNil(upperValue)
  if (thereAreBothLowerAndUpperValues) value = `${label} ${lowerValue} - ${upperValue}`

  return value.trim()
}
